// https://observablehq.com/@namitmohale/horizontal-bar-chart@832
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Horizontal Bar Chart

This chart shows the relative frequency of letters in the English language.`
)});
  main.variable(observer("chart")).define("chart", ["d3","width","height","xAxisG","xAxisTickSize","yScale","margin","yAxisLabelSize","data","yLabel","xScale","color","xLabel","titleTextSize","titleText","xAxisNameSize","xAxisLabelY","xAxisLabel","barTextColor","barTextSize"], function(d3,width,height,xAxisG,xAxisTickSize,yScale,margin,yAxisLabelSize,data,yLabel,xScale,color,xLabel,titleTextSize,titleText,xAxisNameSize,xAxisLabelY,xAxisLabel,barTextColor,barTextSize)
{
  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, height])
  
  const xAxisVar = svg.append('g').call(xAxisG)
      .attr('font-size', xAxisTickSize)
  
  const yAxisVar = svg.append('g')
    .call(d3.axisLeft(yScale))
    .attr('transform', `translate(${margin.left}, 0)`)
    .attr('font-size', yAxisLabelSize)
    .selectAll('text')
      .join('text')
      .attr('font-size', yAxisLabelSize)
  
  // Creates bars
  const barGroups = svg.selectAll('rect')
            .data(data)
            .enter()
            .append('rect')
        
  barGroups
    .attr('class', 'bar')
    .attr('x', margin.left)
    .attr('y', (d, i) => yScale(d[yLabel]))
    .attr('width', (d) => xScale(d))
    .attr('height', yScale.bandwidth())
    .attr('fill', (d) => color(Math.ceil(d[xLabel])))
    .on("mouseenter", function(actual, i){
      d3.select(this)
        .transition()
        .duration(100)
        .attr('opacity', 0.6)
        .attr('y', (a) => yScale(a[yLabel]) - 3)
        .attr('height', yScale.bandwidth() + 6);

      // svg.append('line')
      //   .attr('class', 'limit')
      //   .attr('x1', (a) => xScale(a[xLabel]))
      //   .attr('y1', 0)
      //   .attr('x2', (a) => xScale(a[xLabel]))
      //   .attr('y2', innerHeight)
      //   .style('stroke', 'red')
      //   .style("stroke-width", 2)
    })
  .on('mouseleave', function(){
    d3.select(this)
      .transition()
        .duration(200)
      .attr('opacity', 1)
      .attr('y', (a) => yScale(a[yLabel]))
      .attr('height', yScale.bandwidth())
    svg.selectAll('.limit').remove()
  })
  
  // Animation for On-Load
  svg.selectAll("rect")
    .transition()
      .duration(400)
    .attr("width", function(d) { return xScale(d[xLabel]); })
    .delay(function(d,i){console.log(i) ; return(i*100)})
  
  // Title text
   svg.append('g')
     .attr('font-size', titleTextSize)
     .selectAll('text')
        .data(data)
        .join('text')
        .attr('y', margin.top - 20)
        .attr('x', width/ 2)
    .attr("text-anchor", "middle")
    .style("alignment-baseline", "middle")
     .attr('font-weight', 'bold')
        .text(titleText)
     
  
  // X-axis Label
  xAxisVar.append('g')
    .attr('fill', 'black')
    .attr('font-size', xAxisNameSize)
    .selectAll('text')
      .data(data)
      .join('text')
      .attr('y', yScale(data[0].Perk)-xAxisLabelY)
      .attr('x', xScale(data[0].Amount) / 2)
  .attr("text-anchor", "middle")
    .style("alignment-baseline", "middle")
      .text(xAxisLabel);

  // Text inside bars
  svg.append("g")
    .attr("fill", barTextColor)
    .attr("text-anchor", "end")
    .attr("font-family", "sans-serif")
    .attr("font-size", barTextSize)
    .selectAll("text")
      .data(data)
      .join("text")
      .attr("x", d => xScale(d[xLabel]) + margin.left)
      .attr("y", (d, i) => yScale(d[yLabel]) + yScale.bandwidth() / 2)
      .attr("dy", "0.35em")
      .attr("dx", -4)
      .text(d => d[xLabel])

  return svg.node();
}
);
  main.variable(observer("xAxisLabelY")).define("xAxisLabelY", function(){return(
15
)});
  main.variable(observer("xAxisNameSize")).define("xAxisNameSize", function(){return(
14
)});
  main.variable(observer("titleX")).define("titleX", ["width"], function(width){return(
width/2
)});
  main.variable(observer("keys")).define("keys", ["data"], function(data){return(
Object.keys(data[0])
)});
  main.variable(observer("yLabel")).define("yLabel", ["keys"], function(keys){return(
keys[0]
)});
  main.variable(observer("xLabel")).define("xLabel", ["keys"], function(keys){return(
keys[1]
)});
  main.variable(observer("data")).define("data", function(){return(
[{
      Perk: 'Netflix',
      Amount: 14.99
  },
  {
      Perk: 'Spotify',
      Amount: 9.49
  }
]
)});
  main.variable(observer("xScale")).define("xScale", ["d3","data","xLabel","width","margin"], function(d3,data,xLabel,width,margin){return(
d3.scaleLinear()
            .domain([d3.min(data, d=> d[xLabel])-2, d3.max(data, d => d[xLabel])+1])
            .range([0, width-margin.right-margin.left])
)});
  main.variable(observer("yScale")).define("yScale", ["d3","data","yLabel","margin","innerHeight"], function(d3,data,yLabel,margin,innerHeight){return(
d3.scaleBand()
            .domain(data.map(d => d[yLabel]))
            .range([margin.top, margin.top+innerHeight])
            .padding(0.2)
)});
  main.variable(observer("xAxis")).define("xAxis", ["d3","xScale","innerHeight"], function(d3,xScale,innerHeight){return(
d3.axisBottom(xScale)
            .tickSize(-innerHeight)
)});
  main.variable(observer("xAxisG")).define("xAxisG", ["xAxis","margin","innerHeight"], function(xAxis,margin,innerHeight){return(
g => g
            .call(xAxis)
            .attr('transform', `translate(${margin.left},${margin.top+innerHeight})`)
)});
  main.variable(observer("color")).define("color", ["d3","colorType","data","xLabel"], function(d3,colorType,data,xLabel){return(
d3.scaleOrdinal(d3.quantize(colorType, Math.ceil(d3.max(data, d => d[xLabel]))))
)});
  main.variable(observer("colorType")).define("colorType", ["d3"], function(d3){return(
d3.interpolateCool
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
'10 Most Used Perk Names'
)});
  main.variable(observer("xAxisLabel")).define("xAxisLabel", function(){return(
"Frequency"
)});
  main.variable(observer("yAxisLabelSize")).define("yAxisLabelSize", function(){return(
12
)});
  main.variable(observer("titleTextSize")).define("titleTextSize", function(){return(
18
)});
  main.variable(observer("barTextSize")).define("barTextSize", function(){return(
18
)});
  main.variable(observer("innerWidth")).define("innerWidth", ["width","margin"], function(width,margin){return(
width - margin.left - margin.right
)});
  main.variable(observer("innerHeight")).define("innerHeight", ["height","margin"], function(height,margin){return(
height - margin.bottom - margin.top
)});
  main.variable(observer("xAxisTickSize")).define("xAxisTickSize", function(){return(
12
)});
  main.variable(observer("barTextColor")).define("barTextColor", function(){return(
"#C0C0BB"
)});
  main.variable(observer("barHeight")).define("barHeight", function(){return(
30
)});
  main.variable(observer("height")).define("height", ["data","barHeight","margin"], function(data,barHeight,margin){return(
Math.ceil((data.length + 0.1) * barHeight) + margin.top + margin.bottom
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 40, right: 30, bottom: 50, left: 50}
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  return main;
}
